const gmtFormat = (label) => {
  let gmtFormatValue = label.split(' ')[0].replace(/[()]/g, '');

  if (gmtFormatValue.includes('-')) {
    const hour = gmtFormatValue.split('-')[1].split(':')[0];
    const minutes = gmtFormatValue.split('-')[1].split(':')[1];

    if (hour.length === 1) {
      gmtFormatValue = `${'GMT-0'}${hour}:${minutes}`;
    } else {
      gmtFormatValue = `GMT-${hour}:${minutes}`;
    }
  } else if (gmtFormatValue.includes('+')) {
    const hour = gmtFormatValue.split('+')[1].split(':')[0];
    const minutes = gmtFormatValue.split('+')[1].split(':')[1];

    if (hour.length === 1) {
      gmtFormatValue = `${'GMT+0'}${hour}:${minutes}`;
    } else {
      gmtFormatValue = `GMT+${hour}:${minutes}`;
    }
  } else {
    const hour = gmtFormatValue.split(' ')[1].split(':')[0];
    const minutes = gmtFormatValue.split(' ')[1].split(':')[1];

    if (hour.length === 1) {
      gmtFormatValue = `${'GMT+0'}${hour}:${minutes}`;
    } else {
      gmtFormatValue = `GMT+${hour}:${minutes}`;
    }
  }

  return gmtFormatValue;
};

module.exports = gmtFormat;
